/**
 * QVT Primer Page - Educational content about QVT scores and vascular architecture
 */

import { Layout } from '../components/Layout';
import { PageHeader } from '../components/PageHeader';
import { PageContent } from '../components/PageContent';
import { Card, CardContent, CardTitle } from '../components/ui/card';

export function QVTPrimerPage() {
  return (
    <Layout>
      <PageHeader
        title="QVT Primer"
        description="Understanding QVT scores and vascular architecture analysis"
      />
      <PageContent width="lg">
        <Card>
          <CardContent className="p-6">
            <div className="space-y-4">
              <CardTitle className="text-lg font-semibold">Understanding QVT Scores</CardTitle>
              <div className="space-y-4">
                <div className="flex justify-between text-sm font-medium text-muted-foreground">
                  <div>Lower scores</div>
                  <div>Higher scores</div>
                </div>
                <div className="relative h-8 rounded-md bg-gradient-to-r from-green-500 via-yellow-500 to-red-500">
                  <div className="absolute inset-0 flex items-center justify-center text-xs font-medium">
                    QVT Score
                  </div>
                </div>
                <div className="grid grid-cols-2 gap-4">
                  <div className="space-y-2">
                    <img
                      src="/images/qvt-low.jpg"
                      alt="Low QVT Score"
                      className="w-full rounded-md border"
                    />
                    <div className="text-sm space-y-1">
                      <div>✅ Normalized vasculature</div>
                      <div>✅ Better prognosis</div>
                    </div>
                  </div>
                  <div className="space-y-2">
                    <img
                      src="/images/qvt-high.jpg"
                      alt="High QVT Score"
                      className="w-full rounded-md border"
                    />
                    <div className="text-sm space-y-1">
                      <div>❌ Complex vasculature</div>
                      <div>❌ Worse prognosis</div>
                    </div>
                  </div>
                </div>
                <p className="text-sm text-muted-foreground leading-relaxed">
                  In retrospective studies, tumors with more normalized vascular architecture (e.g.,
                  organized, more linear patterns) have been associated with more favorable outcomes
                  to some standard therapies (e.g., immune checkpoint inhibitors). By contrast,
                  tumors with more complex vascular architecture (e.g., twisted, disorganized
                  patterns) have been associated with less favorable outcomes and lower
                  responsiveness in some settings.
                </p>
              </div>
            </div>
          </CardContent>
        </Card>
      </PageContent>
    </Layout>
  );
}
